export const node = {
	fill: "#fff",
	outerRadius: 30,
	innerRadius: 25,
	textColor: "#101412",

	strokeWidth: "4",
	stroke: "#101412",
	clickedStroke: "#6bb3ff",

	font: "600 15px inter",
};

export const transition = {
	textColor: "#101412",
	lineColor: "#101412",
	placeholderLineColor: "#6bb3ff",
	clickedLineColor: "#6bb3ff",

	arrowLength: 10,
	arrowWidth: 5,
	arrowColor: "#101412",
	placeholderArrowColor: "#6bb3ff",
	clickedArrowColor: "#6bb3ff",

	controlPointHeight: 30,
	controlPointFill: "transparent",
	controlPointStroke: "transparent",
	clickedControlPointStroke: "transparent",

	padding: 25,
};

export const backgroundGrid = {
	fill: "#fff",
	color: "#eee",
	size: 25,
};
